


















































import {
	computed,
	defineComponent,
	PropType,
	watch,
} from '@vue/composition-api';
import { useDiscussionStore } from '@front-app/store/piniaModules/discussions';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import FileShare from '@front-app/components/share/FileShare.vue';
import LinkShare from '@front-app/components/share/LinkShare.vue';
import TabbedNav from '@front-app/components/tabs/TabbedNav.vue';
import { ShareContentPanelState, routeToShareContent, routeToContentInfo } from '@front-app/modules/group/util/shareContentModal';

export default defineComponent({
	components: {
		FileShare,
		LinkShare,
		SlidingPanel,
		TabbedNav,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		selectedType: {
			type: String as PropType<ShareContentPanelState>,
			default: ShareContentPanelState.CLOSED,
		},
		messageId: {
			type: String,
			default: '',
		},
		categories: {
			type: Array as PropType<string[]>,
			required: true,
		},
		maxUploadFileSize: {
			type: Number,
			default: Infinity,
		},
		remainingTotalFileBytes: {
			type: Number,
			default: Infinity,
		},
		canNotifyMembers: Boolean,
		notifyMembersDefault: Boolean,
		canAddNewCategories: Boolean,
	},
	setup(props, ctx) {
		// Routing
		const routeToClose = computed(() => routeToShareContent(ctx, ShareContentPanelState.CLOSED, props.messageId));
		const navigateToContent = async (contentId: string | '') => {
			if (props.messageId) {
				await useDiscussionStore().fetch(props.groupId, props.messageId);
			}
			ctx.root.$router.push(routeToContentInfo(ctx, contentId, ShareContentPanelState.CLOSED, props.messageId));
		};
		// END Routing

		// Message
		const discussionStore = useDiscussionStore();
		const defaultCategories = computed(() => discussionStore.getById(props.messageId)?.categories || []);
		watch(() => props.messageId, (curr, prev) => {
			if (curr && curr !== prev && !discussionStore.getById(props.messageId)) {
				discussionStore.fetch(props.groupId, props.messageId);
			}
		}, { immediate: true });
		// End message

		// Tabs
		const tabButtons = computed(() => [
			{
				key: ShareContentPanelState.FILE,
				label: ctx.root.$t('share-content.share-file') as unknown as string,
				to: routeToShareContent(ctx, ShareContentPanelState.FILE, props.messageId),
			},
			{
				key: ShareContentPanelState.LINK,
				label: ctx.root.$t('share-content.share-link') as unknown as string,
				to: routeToShareContent(ctx, ShareContentPanelState.LINK, props.messageId),
			},
		]);
		// END Tabs

		return {
			ShareContentPanelState,
			routeToClose,
			navigateToContent,
			defaultCategories,
			// Tabs
			tabButtons,
		};
	},
});
